var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowdown = function SvgArrowdown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 6,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B8B8B8",
    d: "M4.583 5.042a.5.5 0 0 1-.798 0L.605.832a.5.5 0 0 1 .4-.8h6.358a.5.5 0 0 1 .4.8z"
  })));
};
export { SvgArrowdown as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSdodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZycKICB3aWR0aD0nOCcKICBoZWlnaHQ9JzYnCiAgdmlld0JveD0nMCAwIDggNicKICBmaWxsPSdub25lJwo+CiAgPHBhdGgKICAgIGQ9J000LjU4MjgyIDUuMDQyMTFDNC4zODI3NyA1LjMwNjk2IDMuOTg0OTIgNS4zMDY5NiAzLjc4NDg3IDUuMDQyMTFMMC42MDUzMTUgMC44MzI2ODRDMC4zNTY1MDUgMC41MDMyODQgMC41OTE0ODEgMC4wMzEzMjE3IDEuMDA0MjkgMC4wMzEzMjE3TDcuMzYzNCAwLjAzMTMyMTFDNy43NzYyMSAwLjAzMTMyMTEgOC4wMTExOCAwLjUwMzI4MyA3Ljc2MjM3IDAuODMyNjgzTDQuNTgyODIgNS4wNDIxMVonCiAgICBmaWxsPScjQjhCOEI4JwogIC8+Cjwvc3ZnPg==";